import React, {useState, useEffect} from "react";
import { useSelector } from "react-redux";
import {Switch, useHistory} from "react-router-dom";

import ListQuotes from "../Pages/listQuotes";
import VerifyQuote from "../Pages/verifyQuote";
import { ApproveQuote } from "../Pages/wizard/ApproveQuote";
import { ClientData } from "../Pages/wizard/ClientData";
import { WorkData } from "../Pages/wizard/WorkData";
import { HealthStatement } from "../Pages/wizard/HealthStatement";
import { Beneficiaries } from "../Pages/wizard/Beneficiaries";
import { AdditionalInfoPart1 } from "../Pages/wizard/AdditionalInfoPart1";
import { AdditionalInfoPart2 } from "../Pages/wizard/AdditionalInfoPart2";
import { VerifySimulation } from "../Pages/wizard/VerifySimulation";
import { thankYouPage } from "../Pages/wizard/thankYouPage";
import { Declaration } from "../Pages/wizard/Declaration";
import ErrorPage from "../Pages/wizard/ErrorPage";
import { OffLine } from "../Pages/wizard/OffLine";

import { ProtectedRoute } from "../Components/privateRoute";
import { DetailPageRV } from "../Pages/wizard/DetailPageRV";
import { ModalitiesPageRV } from "../Pages/wizard/ModalitiesPageRV";

function NestedRoutersQuotations({ path }){
  const elrouter = useHistory()
  const modules = useSelector(
    state => state.login.access_configuration.modules
  );
  const granted = useSelector(
    state => state.login.granted
  );

  const [isInline, setisInline] = useState(true);
  useEffect(() => {
    if (navigator.onLine) {
      setisInline(true);
    }
    window.addEventListener("offline", function () {
      setisInline(false);
    });

    window.addEventListener("online", function () {
      setisInline(true);
    });

    
    window.addEventListener("online", updateOnlineStatus);
    window.addEventListener("offline", updateOnlineStatus);
    
    updateOnlineStatus();

    return () => window.removeEventListener("online", updateOnlineStatus);
  }, []);

  function updateOnlineStatus() {
    navigator.onLine ? console.log("online") :  elrouter.push('/cotizaciones/sin-conexion');
  }
  return (
    <Switch>
      <ProtectedRoute exact path={path} component={ListQuotes} granted={granted} modules={modules} />
      <ProtectedRoute exact path={path + "/verificacion"} component={VerifyQuote}  modules={modules} granted={granted}/>
      <ProtectedRoute exact path={path + "/aprobacion"} component={ApproveQuote}  modules={modules} granted={granted}/>
      <ProtectedRoute exact path={path + "/detalle"} component={DetailPageRV}  modules={modules} granted={granted}/>
      <ProtectedRoute exact path={path + "/detalle-modalidades"} component={ModalitiesPageRV}  modules={modules} granted={granted}/>

      <ProtectedRoute exact path={path + "/datos-personales"} component={ClientData}  modules={modules} granted={granted}/>
      <ProtectedRoute exact path={path + "/datos-laborales"} component={WorkData}  modules={modules} granted={granted}/>
      <ProtectedRoute exact path={path + "/declaracion-de-salud"} component={HealthStatement}  modules={modules} granted={granted}/>
      <ProtectedRoute exact path={path + "/beneficiarios"} component={Beneficiaries}  modules={modules} granted={granted}/>
      <ProtectedRoute exact path={path + "/info-complementaria-1"} component={AdditionalInfoPart1}  modules={modules} granted={granted}/>
      <ProtectedRoute exact path={path + "/info-complementaria-2"} component={AdditionalInfoPart2}  modules={modules} granted={granted}/>
      <ProtectedRoute exact path={path + "/verificacion-simulacion"} component={VerifySimulation}  modules={modules} granted={granted}/>
      
      <ProtectedRoute exact path={path + "/solicitud-cotizacion"} component={thankYouPage}  modules={modules} granted={granted}/>
      <ProtectedRoute exact path={path + "/declaracion-jurada"} component={Declaration}  modules={modules} granted={granted}/>
     
      <ProtectedRoute exact path={path + "/error-simulacion"} component={ErrorPage}  modules={modules} granted={granted}/>
      <ProtectedRoute exact path={path + "/sin-conexion"} component={OffLine}  modules={modules} granted={granted}/>
    </Switch>
  );
};

export default NestedRoutersQuotations;

      
